import { TPlacingOrderDataItem } from '@components/modals/PlacingOrderModalWindow/types';
import { addAddresses, Address, rewriteAddress } from '@api/apiClient';

export const actionAddresses = (forms: TPlacingOrderDataItem[]): void => {
  forms.forEach((item: TPlacingOrderDataItem) => {
    if (item.rememberAddress) {
      const preparedAddress: Address = {
        ...item.address,
        ...(item.addressEnglish && {
          areaEnglish: item.addressEnglish.area,
          cityDistrictEnglish: item.addressEnglish.cityDistrict,
          cityEnglish: item.addressEnglish.city,
          flatEnglish: item.addressEnglish.flat,
          houseEnglish: item.addressEnglish.house,
          rawLineEnglish: item.addressEnglish.rawLine,
          regionEnglish: item.addressEnglish.region,
          streetEnglish: item.addressEnglish.street
        }),
        ...(item.email && { email: item.email }),
        fullName: item.fullName,
        phone: item.phone
      };
      if (item.id === '') {
        addAddresses(preparedAddress);
      } else {
        rewriteAddress({ address: preparedAddress, id: item.id });
      }
    }
  });
};